function getPaymentMethod(payment: any) {
  if (payment.bankAccountDestinationAccountType == 'Cuenta corriente') {
    if (payment.bankAccountDestinationName === 'BANCO DE CHILE') return 1;
    else return 7;
  } else {
    if (payment.bankAccountDestinationName === 'BANCO DE CHILE') return 6;
    else return 8;
  }
}

export default getPaymentMethod;
